import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { DashboardPage } from 'modules/core/pages/DashboardPage'
import { OverallDashboardPage } from 'modules/core/pages/OverallDashboardPage'
import { LoginSelectorPage } from 'modules/auth/pages/LoginSelectorPage'
import { PermitRequestPage } from 'modules/permit/pages/PermitRequestPage'
import { PermitIndexPage } from 'modules/permit/pages/PermitIndexPage'
import { PermitApprovalsPage } from 'modules/permit/pages/PermitApprovalsPage'
import { PermitOpenPage } from 'modules/permit/pages/PermitOpenPage'
import { PermitClosePage } from 'modules/permit/pages/PermitClosePage'
import { PermitDelegationPage } from 'modules/permit/pages/PermitDelegationPage'
import { ApproveContractorPage } from 'modules/permit/pages/ApproveContractorPage'
import { PermitReportPdfPage, PermitReportPreviewPage } from 'modules/permit/pages/PermitReportPreviewPage'
import { NotFoundPage } from './pages/NotFoundPage'
import { EmployeeLoginPage } from 'modules/auth/pages/EmployeeLoginPage'
import { EmployeeAzureCallbackPage } from 'modules/auth/pages/EmployeeAzureCallbackPage'
import { ContractorLoginPage } from 'modules/auth/pages/ContractorLoginPage'
import { ContractorAzureCallbackPage } from 'modules/auth/pages/ContractorAzureCallbackPage'
import { ContractorAzureOnboardingPage } from 'modules/auth/pages/ContractorAzureOnboardingPage'
import { ContractorForgotPasswordPage } from 'modules/auth/pages/ContractorForgotPasswordPage'
import { ContractorResetPasswordPage } from 'modules/auth/pages/ContractorResetPasswordPage'
import { ModuleSelectionPage } from 'modules/core/pages/ModuleSelectionPage'
import { SiteSelectionPage } from 'modules/core/pages/SiteSelectionPage'
import { AdminModulePage } from 'modules/admin/pages/AdminModulePage'
import { AuditEntryPage } from 'modules/audit/pages/AuditEntryPage'
import { PermitAuditListPage } from 'modules/audit/pages/PermitAuditListPage'
import { PermitAuditEditorPage } from 'modules/audit/pages/PermitAuditEditorPage'
import { TimesheetListPage } from 'modules/timesheet/pages/TimesheetListPage'
import { TimesheetEditorPage } from 'modules/timesheet/pages/TimesheetEditorPage'
import { SystemBrandingProvider } from 'shared/branding/SystemBrandingProvider'
import { EptwLayout } from './layout/EptwLayout'
import '../App.css'

function App() {
  return (
    <SystemBrandingProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="/login" element={<LoginSelectorPage />} />
          <Route path="/login/employee" element={<EmployeeLoginPage />} />
          <Route path="/login/employee/azure/callback" element={<EmployeeAzureCallbackPage />} />
          <Route path="/login/contractor" element={<ContractorLoginPage />} />
          <Route path="/login/contractor/azure/callback" element={<ContractorAzureCallbackPage />} />
          <Route path="/login/contractor/azure/onboarding" element={<ContractorAzureOnboardingPage />} />
          <Route path="/login/contractor/forgot" element={<ContractorForgotPasswordPage />} />
          <Route path="/login/contractor/reset" element={<ContractorResetPasswordPage />} />
          <Route path="/modules" element={<ModuleSelectionPage />} />
          <Route path="/sites/select" element={<SiteSelectionPage />} />
          <Route path="/admin/*" element={<AdminModulePage />} />
          <Route path="/permit-report-pdf/:permitId" element={<PermitReportPdfPage />} />

          <Route element={<EptwLayout />}>
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/overall-dashboard" element={<OverallDashboardPage />} />
            <Route path="/permit-request" element={<PermitRequestPage />} />
            <Route path="/permit-index" element={<PermitIndexPage />} />
            <Route path="/permit-approvals" element={<PermitApprovalsPage />} />
            <Route path="/permit-open" element={<PermitOpenPage />} />
            <Route path="/permit-close" element={<PermitClosePage />} />
            <Route path="/permit-delegation" element={<PermitDelegationPage />} />
            <Route path="/approve-contractor" element={<ApproveContractorPage />} />
            <Route path="/audit-entry" element={<AuditEntryPage />} />
            <Route path="/permit-audit" element={<PermitAuditListPage />} />
            <Route path="/permit-audit/create" element={<PermitAuditEditorPage />} />
            <Route path="/permit-audit/:auditId" element={<PermitAuditEditorPage />} />
            <Route path="/permit-audit/:auditId/view" element={<PermitAuditEditorPage />} />
            <Route path="/timesheet" element={<TimesheetListPage />} />
            <Route path="/timesheet/create" element={<TimesheetEditorPage />} />
            <Route path="/timesheet/:permitId" element={<TimesheetEditorPage />} />
            <Route path="/timesheet/:permitId/view" element={<TimesheetEditorPage />} />
            <Route path="/permit-report-preview/:permitId" element={<PermitReportPreviewPage />} />
          </Route>

          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </BrowserRouter>
    </SystemBrandingProvider>
  )
}

export default App
